import React, { useMemo } from "react";
import SelectObjectTypeahead from "../ui/SelectObjectTypeahead";

interface RoomFilterSelectState {
  rooms: any[];
  // a room, "0" for all rooms, or nothing picked yet
  filterRoom: any;
  onUpdate: (room: any) => void;
  disabled?: boolean;
}

export const STANDALONE_ROOMS_LABEL = "Standalone Rooms";

// Room picker for Bed Occupancy / Bed Inspection: "View All", then one group per facility, then the
// standalone rooms. `rooms` arrive already ordered (sortRoomsForFilter) and carry a `facility_name`.
const RoomFilterSelect = ({ rooms, filterRoom, onUpdate, disabled = false }: RoomFilterSelectState) => {
  const viewAll = { value: "0", label: "View All", original: { key: "0", name: "View All" } };

  const { options, flat } = useMemo(() => {
    const groups = new Map<string, any[]>();
    rooms.forEach((room: any) => {
      const label = room.facility_name || STANDALONE_ROOMS_LABEL;
      if (!groups.has(label)) groups.set(label, []);
      groups.get(label)!.push({ value: room.key, label: room.name, original: room });
    });
    const standalone = groups.get(STANDALONE_ROOMS_LABEL);
    groups.delete(STANDALONE_ROOMS_LABEL);
    const grouped = [...Array.from(groups.entries()), ...(standalone ? [[STANDALONE_ROOMS_LABEL, standalone] as [string, any[]]] : [])];
    const groupOptions = grouped.map(([label, groupRooms]) => ({ label, options: groupRooms }));
    return { options: [viewAll, ...groupOptions], flat: [viewAll, ...grouped.flatMap(([, groupRooms]) => groupRooms)] };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rooms]);

  const value = filterRoom === "0" ? viewAll : filterRoom?.key ? (flat.find((o: any) => o.value === filterRoom.key) ?? null) : null;

  return (
    <SelectObjectTypeahead
      label="Select a Room"
      value={value}
      options={options as any}
      onUpdate={(selected: any) => selected && onUpdate(selected)}
      disabled={disabled}
      groupHeading
    />
  );
};

export default RoomFilterSelect;
